import React from 'react';
import PageContainer from '../../components/container/PageContainer';
import Navbar from '../../layouts/full-layout/header/homeHeader';
import { Box, Typography } from '@mui/material';
import Footer from '../../layouts/full-layout/footer/Footer';
import BgImage from '../../assets/backgrounds/poster.jpg';

const PrivacyPolicy = () => {
  return (
    <PageContainer title="Privacy Policy" description="This is Privacy Policy Page">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        {/* <Navbar /> */}

        {/* Main Content */}
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundImage: `url(${BgImage})`, // Make sure the background image is wrapped in `url()`
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            marginTop: '120px',
          }}
        >
          <Typography variant="h1" fontWeight="bold">
            Privacy & Policy
          </Typography>

          <Box p={5}>
            <Typography variant="h3">
              Your privacy is critically important to us. It is Behtar@75’s policy to respect your
              privacy regarding any information we may collect while operating our website. This
              Privacy Policy applies to visitors. We respect your privacy and are committed to
              protecting personally identifiable information you may provide us through the Website.
              We have adopted this privacy policy to explain what information may be collected on
              our Website, how we use this information, and under what circumstances we may disclose
              the information to third parties. This Privacy Policy applies only to information we
              collect through the Website and does not apply to our collection of information from
              other sources. We only retain collected information for as long as necessary to
              provide you with your requested service. What data we store, we’ll protect within
              commercially acceptable means to prevent loss and theft, as well as unauthorized
              access, disclosure, copying, use, or modification. We only retain collected
              information for as long as necessary to provide you with your requested service. What
              data we store, we’ll protect within commercially acceptable means to prevent loss and
              theft, as well as unauthorized access, disclosure, copying, use, or modification. This
              Privacy Policy applies only to our online activities and is valid for visitors to our
              website with regards to the information that they shared and/or collected in
              Behtar@75.in This policy is not applicable to any information collected offline or via
              channels other than this website. If you have additional questions or require more
              information about our Privacy Policy, do not hesitate to contact us.
            </Typography>
            <ol>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  Consent
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      By using our website, you hereby consent to our Privacy Policy and agree to
                      its terms.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  Information We Collect
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      For the Temples which form a part of the website at http://behtar75.in/ and
                      redirects to a page within the website may collect certain personal
                      information that you are asked to provide, and the reasons why you are asked
                      to provide it, will be made clear to you at the point we ask you to provide
                      your personal information.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="h3">
                      If you contact us directly, we may receive additional information about you
                      such as your name, email address, phone number, the contents of the message
                      and/or attachments you may send us, and any other information you may choose
                      to provide.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="h3">
                      If and when you register for an Account, we may ask for your contact
                      information, including items such as name, company name, address, email
                      address, and telephone number.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  How we use your information
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      We use the information we collect in various ways, including
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="h3">
                      If you contact us directly, we may receive additional information about you
                      such as your name, email address, phone number, the contents of the message
                      and/or attachments you may send us, and any other information you may choose
                      to provide.
                    </Typography>
                    <ul>
                      <li>
                        <Typography variant="h3">
                          Provide, operate, and maintain our website
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="h3">
                          Improve, personalize, and expand our website.
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="h3">
                          Understand and analyse how you use our website.
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="h3">
                          Develop new products, services, features, and functionality.
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="h3">
                          Communicate with you, either directly or through one of our partners,
                          including for customer service, to provide you with updates and other
                          information relating to the website, and for marketing and promotional
                          purposes.
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="h3">Send you emails.</Typography>
                      </li>
                      <li>
                        <Typography variant="h3">Find and prevent fraud.</Typography>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  Website Visitors
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      Like most website operators, Behtar@75 collects non-personally identifying
                      information of the sort that web browsers and servers typically make
                      available, such as the browser type, language preference, referring site, and
                      the date and time of each visitor request. Behtar@75’s purpose in collecting
                      non-personally identifying information is to better understand how Behtar@75
                      visitors use its website. From time to time, Behtar@75 may release
                      non-personally identifying information in the aggregate, e.g., by publishing a
                      report on trends in the usage of its website.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="h3">
                      Behtar@75 also collects potentially personally-identifying information like
                      Internet Protocol (IP) addresses for logged-in users and for users leaving
                      comments on http://behtar75.in/ blog posts. Behtar@75 only discloses logged-in
                      user and commenter IP addresses under the same circumstances that it uses and
                      discloses personally-identifying information as described below.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  Log Files
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      We follow a standard procedure of using log files. These files log visitors
                      when they visit websites. All hosting companies do this and are a part of
                      hosting services’ analytics. The information collected by log files includes
                      internet protocol (IP) addresses, browser type, Internet Service Provider
                      (ISP), date and time stamp, referring/exit pages, and possibly the number of
                      clicks. These are not linked to any information that is personally
                      identifiable. The purpose of the information is for analyzing trends,
                      administering the site, tracking users’ movement on the website, and gathering
                      demographic information.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  Cookies and Web Beacons
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      Like any other website, http://behtar75.in/ uses ‘cookies’. These cookies are
                      used to store information including visitors’ preferences, and the pages on
                      the website that the visitor accessed or visited. The information is used to
                      optimize the users’ experience by customizing our web page content based on
                      visitors’ browser type and/or other information.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="h3">
                      A cookie is a string of information that a website stores on a visitor’s
                      computer, and that the visitor’s browser provides to the website each time the
                      visitor returns. Behtar@75 uses cookies to help Behtar@75 identify and track
                      visitors, their usage of http://behtar75.in/ , and their website access
                      preferences. Behtar@75 visitors who do not wish to have cookies placed on
                      their computers should set their browsers to refuse cookies before using
                      Behtar@75’s websites, with the drawback that certain features of Behtar@75’s
                      websites may not function properly without the aid of cookies.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="h3">
                      By continuing to navigate our website without changing your cookie settings,
                      you hereby acknowledge and agree to Behtar@75’s use of cookies.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  Advertising Partners Privacy Policies
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      You may consult this list to find the Privacy Policy for each of the
                      advertising partners of https://Behtar75.in
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="h3">
                      Third-party ad servers or ad networks uses technologies like cookies,
                      JavaScript, or Web Beacons that are used in their respective advertisements
                      and links that appear on https://Behtar75.in, which are sent directly to
                      users’ browser. They automatically receive your IP address when this occurs.
                      These technologies are used to measure the effectiveness of their advertising
                      campaigns and/or to personalize the advertising content that you see on
                      websites that you visit.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="h3">
                      Note that https://Behtar75.in has no access to or control over these cookies
                      that are used by third-party advertisers.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  Third Party Privacy Policies
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      Privacy Policy does not apply to other advertisers or websites. Thus, we are
                      advising you to consult the respective Privacy Policies of these third-party
                      ad servers for more detailed information. It may include their practices and
                      instructions about how to opt out of certain options.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="h3">
                      You can choose to disable cookies through your individual browser options. To
                      know more detailed information about cookie management with specific web
                      browsers, it can be found on the browsers’ respective websites.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  Security
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      The security of your Personal Information is important to us, but remember
                      that no method of transmission over the Internet, or method of electronic
                      storage is 100% secure. While we strive to use commercially acceptable means
                      to protect your Personal Information, we cannot guarantee its absolute
                      security.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  Aggregated Statistics
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      Behtar@75 may collect statistics about the behavior of visitors to its
                      website. Behtar@75 may display this information publicly or provide it to
                      others. However, Behtar@75 does not disclose your personally-identifying
                      information.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  E-commerce
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      Those who engage in transactions with Behtar@75 – by purchasing Behtar@75’s
                      services or products, are asked to provide additional information, including
                      as necessary the personal and financial information required to process those
                      transactions. In each case, Behtar@75 collects such information only insofar
                      as is necessary or appropriate to fulfill the purpose of the visitor’s
                      interaction with Behtar@75. Behtar@75 does not disclose personally-identifying
                      information other than as described below. And visitors can always refuse to
                      supply personally-identifying information, with the caveat that it may prevent
                      them from engaging in certain website-related activities.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  Children’s Information
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      Another part of our priority is adding protection for children while using the
                      internet. We encourage parents and guardians to observe, participate in,
                      and/or monitor and guide their online activity.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="h3">
                      We do not knowingly collect any Personal Identifiable Information from
                      children under the age of 18. If you think that your child provided this kind
                      of information on our website, we strongly encourage you to contact us
                      immediately and we will do our best efforts to promptly remove such
                      information from our records.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  Privacy Policy Changes
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      Although most changes are likely to be minor, Behtar@75 may change its Privacy
                      Policy from time to time, and at Behtar@75’s sole discretion. Behtar@75
                      encourages visitors to frequently check this page for any changes to its
                      Privacy Policy. Your continued use of this site after any change in this
                      Privacy Policy will constitute your acceptance of such change.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="h2" fontWeight="bold">
                  Compliance with Laws and Regulations, and Commitment to this Policy
                </Typography>
                <ul>
                  <li>
                    <Typography variant="h3">
                      We fully abide by all the laws and regulations concerning personal information
                      protection under the Laws of India. Moreover, we are committed to compliance
                      with the provisions of this Privacy Policy.
                    </Typography>
                  </li>
                </ul>
              </li>
            </ol>
          </Box>
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </PageContainer>
  );
};

export default PrivacyPolicy;
